/** Where the operator lands after deleting a job (owner decision September 24, 2026).
 * Deleting from the job door, on the main screen, lands on the next job in the same
 * list the door shows. Deleting inside Scan jobs keeps Scan jobs open, and with no job
 * left Scan jobs opens so a new one can be made. */
export type JobDeletionLanding = { screen: 'jobs' } | { screen: 'job'; jobId: string };

export function landingAfterJobDeletion(
  jobIds: readonly string[],
  deletedId: string,
  fromJobDoor: boolean,
): JobDeletionLanding {
  const remaining = jobIds.filter((id) => id !== deletedId);
  if (!fromJobDoor || remaining.length === 0) return { screen: 'jobs' };
  const at = Math.max(0, jobIds.indexOf(deletedId));
  return { screen: 'job', jobId: remaining[Math.min(at, remaining.length - 1)] };
}
